<template>
    <main class="product" :class="{ fixed: $route.name === 'product.simulator' }" v-if="product">
        <primary-navigation />
        <nav>
            <div class="constrain bc flex flex-align">
                <router-link class="destination" :to="{ name: 'product.contents' }">Table of Contents</router-link>
                <router-link class="destination" :to="{ name: 'product.exercises' }"
                    v-if="product.license_type === 'teacher'">Exercises</router-link>
                <router-link class="destination" :to="{ name: 'product.assignments' }">Assignments</router-link>
                <router-link class="destination" :to="{ name: 'product.simulator' }"
                    v-if="product.product_slug !== 'anatomy'">Simulator</router-link>
                <div class="ff"></div>
                <a @click="reprocess" v-if="user.user_admin" class="text-button">Reprocess Product</a>
            </div>
        </nav>
        <template v-if="product">
            <router-view :key="product.product_id" />
        </template>
    </main>
</template>

<script>
export default {
    name: 'Product',
    methods: {
        reprocess() {
            this.$http.post(`/products/${this.product.product_id}`, {})
                .then(() => this.$toasted.success(`Successfully reimported ${this.product.product_title}.`))
                .catch(() => this.$toasted.error(`Failed to reimport ${this.product.product_title}.`));
        }
    },
    computed: {
        product() {
            return this.$store.getters.product;
        },
        user() {
            return this.$store.state.user;
        }
    },
    created() {
        //Activate a product based on the URL slug.
        console.log('activating', this.$route.params.product);
        const product = this.$store.getters.products.find(product => product.product_slug === this.$route.params.product);

        if (product) {
            this.$store.dispatch('products/activate', product);
        }
    }
}
</script>

<style scoped lang="less">
@import "~@/assets/less/variables";

.product {
    nav {
        border-bottom: 1px solid var(--border-color);
    }

    &.fixed {
        height: 100vh;
        width: 100vw;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        .product-simulator {
            flex: 1;
        }
    }
}
</style>
